// Copy for the Intelligence nav cluster (Phase 2 task 2.3). Each report tab
// opens with a headline insight rendered above the chart/table. Strings here
// are templated — the numbers are interpolated in the derivation helpers.

export const intelligenceCopy = {
  // Section label in the left nav
  sectionIntelligence: 'Intelligence',
  sectionToday: 'Today',
  sectionWork: 'Work',

  // Common framing
  noSignalYet: 'Not enough data yet to summarise.',
  noSignalHint: 'A headline appears once reports have a full period of data to compare.',

  // Capacity
  capacityOverloaded: 'The next {weeks} weeks are overloaded at {avg}% average utilisation.',
  capacityBusy: 'The next {weeks} weeks look busy at {avg}% average utilisation.',
  capacityHealthy: 'The next {weeks} weeks are on track at {avg}% average utilisation.',
  capacityPeakWeek: 'Peak load is the week of {date} at {peak}%.',
  capacityDeltaRise: 'Load rises {delta} points from this week to {peakDate}.',
  capacityDeltaSteady: 'Load is steady across the forecast window.',

  // Time allocation
  timeAllocationBalanced:
    '{focusPct}% of your time went to focused work this period, {meetingPct}% to meetings.',
  timeAllocationMeetingHeavy:
    'Meetings took {meetingHours}h this period, leaving {focusHours}h for focused work.',
  timeAllocationTopDriver: '{driverName} absorbed {driverPct}% of the time logged.',

  // Delegation
  delegationActive:
    'You delegated {total} items this period with a {completionPct}% completion rate.',
  delegationTurnaround: 'Average turnaround was {days} days across {delegatees} delegatees.',
  delegationNone: 'No items were delegated this period.',

  // Executive / My Reports
  executiveOnTrack: 'You closed {done} of {total} planned items this period, {donePct}% through.',
  executiveCarryForward:
    '{carried} items carried forward. {longCarry} have been carrying for four days or more.',
  executiveEmpty: 'No work items matched this date range.',

  // Generic headline header prefix
  headlineLabel: 'Headline',
} as const;
